export default function COUNTA() {
  return (
    <div className="p-4">
      <h1>COUNTA</h1>
    </div>
  );
}
